import { productActions } from "@/lib/redux/features/product/reduce"
import { useAppDispatch, useAppSelector } from "../redux"

export const useSelectedAspect = () => {
  const selectedAspectLabel = useAppSelector(state => state.product.productDetailState.selectedAspectLabel)
  const dispatch = useAppDispatch()

  const onSelectAspect = (aspectLabel: string) => {
      dispatch(productActions.selectAspectLabel(aspectLabel))
    }

  return {
    aspect: selectedAspectLabel,
    onSelect: onSelectAspect
  }
}

export default useSelectedAspect